/* LaFarmacia - extras del nuevo diseno (8 oct 2026, pedidos de Claudia)
   Se carga desde sections/footer.liquid (esta en todas las paginas), con defer.

   1) FAVORITOS EN TODA LA WEB
      Corazon en cada tarjeta de producto (home: Ofertas flash y Mas vendidos;
      colecciones; resultados de busqueda; relacionados de la ficha). Usa la
      misma lista que ya usaban el corazon de la ficha (snippets/
      product-media-gallery.liquid) y el panel del corazon del header
      (layout/theme.liquid): localStorage "laf_favs" con los handles.

   2) BOTON "AVISAME CUANDO ESTE DISPONIBLE" (ficha de producto agotado)
      Sustituye al script inline que habia al final de layout/theme.liquid:
      ese script solo crea el boton si todavia no existe ninguno
      (.laf-avisame-btn), y como este archivo es "defer" corre antes del
      DOMContentLoaded en el que se ejecuta aquel, asi que el de aqui gana y
      aquel no hace nada. Cambios respecto al anterior:
        - "Agotado" a la IZQUIERDA en gris y "Avisame" a la DERECHA, mismo tamano
          (ver laf-extras.css).
        - Ademas del aviso de stock (app propia en Railway), suscribe el email
          a la newsletter en CONNECTIF (proveedor de NL) y tambien como
          cliente de Shopify con consentimiento de marketing.
        - El aviso se da por registrado cuando responde la app de stock; si la
          suscripcion a NL falla no bloquea el aviso (queda en consola).
      Si este archivo fallara al cargar, el script antiguo sigue funcionando
      como respaldo.

   4) FICHA: miniaturas a la izquierda + galeria a pantalla completa al
      tocar la foto (markup en snippets/product-media-gallery.liquid).

   3) "Anadir" desde el panel de favoritos: la cesta no se abre sola; aviso
      igual al del buscador (laf-cart.js). */
(function(){
  if(window.__lafExtras) return; window.__lafExtras = true;

  function onReady(fn){
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', fn); } else { fn(); }
  }

  /* =========================================================
     1) FAVORITOS
     ========================================================= */
  var FKEY = 'laf_favs';
  function getFavs(){ try { var a = JSON.parse(localStorage.getItem(FKEY) || '[]'); return Array.isArray(a) ? a : []; } catch(e){ return []; } }
  function setFavs(a){ try { localStorage.setItem(FKEY, JSON.stringify(a)); } catch(e){} }

  /* Orden de la lista: el mas nuevo PRIMERO (asi la muestra el panel del
     header). Antes se agregaban al final; las listas que ya tenian los
     clientes se invierten una sola vez para que queden en el orden nuevo. */
  try {
    if(localStorage.getItem('laf_favs_orden') !== 'nuevo-primero'){
      setFavs(getFavs().reverse());
      localStorage.setItem('laf_favs_orden', 'nuevo-primero');
    }
  } catch(e){}

  function handleFromHref(href){
    var m = (href || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  var HEART = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';

  /* card: la tarjeta; box: donde va el corazon (la caja de la imagen) */
  var CARDS = [
    { card: '.laf-bcard:not(.laf-bcard--more)', box: '.laf-bcard__imgwrap' },   // Mas vendidos (home)
    { card: '.laf-card:not(.laf-card--more)',   box: '.laf-card__imgwrap, .laf-thumb' }, // Ofertas flash (home) y resultados de busqueda
    { card: '.lafr__card',                      box: '.lafr__img' },            // Relacionados de la ficha
    { card: '.card-wrapper',                    box: '.card__inner' }           // Tarjetas Dawn (colecciones, etc.)
  ];

  function pintarBoton(btn, favs){
    var on = favs.indexOf(btn.getAttribute('data-handle')) >= 0;
    btn.classList.toggle('is-fav', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Quitar de favoritos' : 'Añadir a favoritos');
  }

  function actualizarTodo(){
    var favs = getFavs();
    document.querySelectorAll('.laf-fav-btn').forEach(function(b){ pintarBoton(b, favs); });
    var header = document.querySelector('.laf-header-heart');
    if(header){ header.classList.toggle('laf-tiene-favs', favs.length > 0); }
    // Corazon de la ficha (product-media-gallery.liquid)
    document.querySelectorAll('.laf-pdp-fav[data-handle]').forEach(function(f){
      var on = favs.indexOf(f.getAttribute('data-handle')) >= 0;
      var svg = f.querySelector('svg');
      f.style.color = on ? '#e8352e' : '#6b7780';
      if(svg){ svg.setAttribute('fill', on ? '#e8352e' : 'none'); }
    });
  }
  // La ficha ya llama a window.lafActualizarFavs al tocar su corazon
  window.lafActualizarFavs = actualizarTodo;

  function ponerCorazones(scope){
    var favs = getFavs();
    CARDS.forEach(function(rule){
      (scope || document).querySelectorAll(rule.card).forEach(function(card){
        if(card.__lafFav) return;
        var link = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
        var handle = link && handleFromHref(link.getAttribute('href'));
        var box = card.querySelector(rule.box);
        if(!handle || !box) return;
        card.__lafFav = true;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'laf-fav-btn';
        btn.setAttribute('data-handle', handle);
        btn.innerHTML = HEART;
        box.classList.add('laf-fav-host');
        box.appendChild(btn);
        pintarBoton(btn, favs);
      });
    });
  }

  // Un solo manejador (captura) para todos los corazones: evita que el clic
  // abra el producto cuando la tarjeta entera es un enlace.
  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('.laf-fav-btn') : null;
    if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    var favs = getFavs();
    var i = favs.indexOf(handle);
    if(i >= 0){ favs.splice(i, 1); } else { favs.unshift(handle); } // el mas nuevo primero
    setFavs(favs);
    actualizarTodo();
    if(i < 0 && window.lafVolarCorazon){ window.lafVolarCorazon(btn); }
  }, true);

  // Al quitar un favorito desde el panel del header, refrescar los corazones
  document.addEventListener('click', function(e){
    if(e.target.closest && e.target.closest('.laf-fav-item-remove')){ setTimeout(actualizarTodo, 0); }
  });
  window.addEventListener('storage', function(e){ if(e.key === FKEY){ actualizarTodo(); } });

  onReady(function(){
    ponerCorazones();
    actualizarTodo();
    // Contenido que llega despues (cargar mas, filtros, buscador, etc.)
    if(window.MutationObserver){
      var pendiente = null;
      new MutationObserver(function(){
        if(pendiente) return;
        pendiente = setTimeout(function(){ pendiente = null; ponerCorazones(); }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
  });

  /* =========================================================
     3) Panel de favoritos: anadir sin abrir la cesta
     ========================================================= */
  var refrescarAnterior = window.lafRefrescarCarritoSilencioso;
  window.lafRefrescarCarritoSilencioso = function(data){
    if(window.lafCart && window.lafCart.applySections && data && data.sections){
      window.lafCart.applySections(data.sections);
      window.lafCart.toast('Añadido a la cesta');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }
    if(refrescarAnterior){ refrescarAnterior(data); }
  };

  /* =========================================================
     2) AVISAME CUANDO ESTE DISPONIBLE
     ========================================================= */
  var BACKEND = 'https://laf-avisos-stock-production.up.railway.app';
  var AKEY = 'laf_avisos_stock';

  function getAvisos(){ try { return JSON.parse(localStorage.getItem(AKEY) || '[]'); } catch(e){ return []; } }
  function yaAvisado(url){ return getAvisos().some(function(a){ return a.url === url; }); }

  function iconoCampana(grande){
    var s = grande ? 22 : 18;
    var fill = grande ? 'currentColor' : 'none';
    return '<svg width="'+s+'" height="'+s+'" viewBox="0 0 24 24" fill="'+fill+'" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>';
  }

  function ponerActivado(btn){
    btn.className = 'laf-avisame-btn activado';
    btn.innerHTML = iconoCampana(true) + '<span>Aviso activado</span>';
    btn.disabled = true;
  }

  /* --- Newsletter en Connectif ---
     Se usa el script de Connectif que ya carga su app embed de Shopify
     (window.connectif.managed). Se envia el evento de suscripcion a
     newsletter con el email, y la ficha de contacto con ese email como
     clave y estado "subscribed". Si el script todavia no esta listo se
     espera a su evento de inicializacion (maximo 6 s). */
  function suscribirConnectif(email){
    return new Promise(function(resolve){
      var terminado = false;
      function fin(ok, motivo){ if(terminado) return; terminado = true; if(!ok){ console.warn('[LaF avisame] Connectif:', motivo); } resolve(ok); }
      function listo(){ return window.connectif && window.connectif.managed && typeof window.connectif.managed.sendEvents === 'function' && (typeof window.connectif.managed.isInitialized !== 'function' || window.connectif.managed.isInitialized()); }
      function enviar(){
        try {
          window.connectif.managed.sendEvents(
            [{ type: 'newsletter-subscribe', email: email }],
            {
              entityInfo: { primaryKey: email, _newsletterSubscriptionStatus: 'subscribed' },
              onResponded: function(){ fin(true); }
            }
          );
          setTimeout(function(){ fin(true); }, 3000);
        } catch(e){ fin(false, e && e.message); }
      }
      if(listo()){ enviar(); return; }
      document.addEventListener('connectif.managed.initialized', function(){ if(listo()){ enviar(); } }, { once: true });
      var intentos = 0;
      var t = setInterval(function(){
        intentos++;
        if(listo()){ clearInterval(t); enviar(); }
        else if(intentos > 30){ clearInterval(t); fin(false, 'script de Connectif no disponible'); }
      }, 200);
    });
  }

  /* --- Newsletter como cliente de Shopify (consentimiento de marketing) ---
     Mismo formulario que el de la newsletter del pie. Si Shopify pide
     verificacion anti-bots (redirige a /challenge) no se puede completar
     en segundo plano; queda avisado en consola. */
  function suscribirShopify(email){
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'newsletter,aviso-stock');
    fd.append('contact[accepts_marketing]', 'true');
    return fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function(r){
        var ok = r.ok && (r.url || '').indexOf('/challenge') < 0;
        if(!ok){ console.warn('[LaF avisame] Shopify newsletter no confirmada (' + r.status + ' ' + r.url + ')'); }
        return ok;
      })
      .catch(function(e){ console.warn('[LaF avisame] Shopify newsletter:', e && e.message); return false; });
  }

  function botonAgotado(){
    var lista = document.querySelectorAll('product-form .product-form__submit, .product-form__buttons button[type=submit]');
    for(var i = 0; i < lista.length; i++){
      var b = lista[i];
      if(b.disabled && b.textContent.toLowerCase().indexOf('agotado') >= 0){ return b; }
    }
    return null;
  }

  function initAvisame(){
    if(document.querySelector('.laf-avisame-btn')) return;
    var agotado = botonAgotado();
    if(!agotado) return;

    var productoTitulo = ((document.querySelector('.product__title h1, .product__title') || {}).textContent || document.title).trim();
    var productoUrl = window.location.href.split('?')[0].split('#')[0];

    var variantId = '';
    var form = agotado.closest('form');
    var variantInput = (form && form.querySelector('input[name="id"]')) || document.querySelector('.product-form__buttons input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if(variantInput){ variantId = variantInput.value; }
    var productImage = '';
    var imgEl = document.querySelector('.product__media img, .product-media img, .product__media-item img');
    if(imgEl){ productImage = imgEl.currentSrc || imgEl.src; if(productImage && productImage.indexOf('//') === 0){ productImage = 'https:' + productImage; } }

    agotado.classList.add('laf-agotado-btn');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'laf-avisame-btn';
    btn.innerHTML = iconoCampana(false) + '<span>Avísame cuando esté disponible</span>';
    // Avisame a la DERECHA del boton "Agotado"
    agotado.parentNode.insertBefore(btn, agotado.nextSibling);

    if(yaAvisado(productoUrl)){ ponerActivado(btn); return; }

    var panel = document.createElement('div');
    panel.className = 'laf-avisame-panel';
    panel.innerHTML =
      '<input type="email" class="laf-avisame-email" placeholder="tu@email.com" autocomplete="email" aria-label="Tu email">' +
      '<div class="laf-avisame-checks">' +
        '<label class="laf-avisame-check">' +
          '<input type="checkbox" class="laf-avisame-c-aviso">' +
          '<span>Autorizo el envío de información a mi correo electrónico y suscribirme a la newsletter.</span>' +
        '</label>' +
        '<div class="laf-avisame-check" style="cursor:default;">' +
          '<span style="font-size:11.5px;color:#8a9691;">Consulta nuestra <a href="/policies/privacy-policy" target="_blank" rel="noopener">política de privacidad</a>.</span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="laf-avisame-enviar">Confirmar aviso</button>';
    var contBotones = agotado.closest('.product-form__buttons') || agotado.parentNode;
    contBotones.parentNode.insertBefore(panel, contBotones.nextSibling);

    btn.addEventListener('click', function(){
      panel.classList.toggle('abierto');
      if(panel.classList.contains('abierto')){ panel.querySelector('.laf-avisame-email').focus(); }
    });

    var enviar = panel.querySelector('.laf-avisame-enviar');
    enviar.addEventListener('click', function(){
      var emailInput = panel.querySelector('.laf-avisame-email');
      var cAviso = panel.querySelector('.laf-avisame-c-aviso');
      var email = emailInput.value.trim();
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ emailInput.style.borderColor = '#e8352e'; emailInput.focus(); return; }
      emailInput.style.borderColor = '';
      if(!cAviso.checked){ cAviso.parentNode.style.color = '#e8352e'; return; }
      enviar.disabled = true;
      enviar.textContent = 'Enviando…';

      // Newsletter (Connectif + Shopify) en paralelo; no bloquea el aviso.
      suscribirConnectif(email);
      suscribirShopify(email);

      fetch(BACKEND + '/api/aviso', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, variant_id: variantId, product_title: productoTitulo, product_url: productoUrl, product_image: productImage })
      })
        .then(function(r){ return r.json(); })
        .then(function(data){
          if(!(data && data.ok)){ throw new Error('backend no ok'); }
          try {
            var avisos = getAvisos();
            avisos.push({ email: email, producto: productoTitulo, url: productoUrl, fecha: new Date().toISOString() });
            localStorage.setItem(AKEY, JSON.stringify(avisos));
          } catch(e){}
          panel.remove();
          ponerActivado(btn);
          if(window.lafCart && window.lafCart.toast){ window.lafCart.toast('¡Listo! Te avisaremos cuando vuelva a estar disponible'); }
        })
        .catch(function(){
          enviar.disabled = false;
          enviar.textContent = 'Confirmar aviso';
          alert('No se pudo registrar el aviso. Inténtalo de nuevo.');
        });
    });
  }

  onReady(initAvisame);

  /* =========================================================
     4) FICHA: miniaturas a la izquierda + galeria (lightbox)
     ========================================================= */
  function initGaleria(){
    var gallery = document.querySelector('media-gallery');
    var thumbs = gallery && gallery.querySelector('[data-laf-thumbs]');
    if(!gallery || !thumbs) return;
    var imgs = [];
    try { imgs = JSON.parse((gallery.querySelector('[data-laf-gallery-json]') || {}).textContent || '[]'); } catch(e){ imgs = []; }
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');

    function marcar(target){
      thumbs.querySelectorAll('.laf-thumbs__item[data-target]').forEach(function(b){
        b.classList.toggle('is-active', b.getAttribute('data-target') === target);
      });
    }
    function activa(){
      var a = viewer && viewer.querySelector('.product__media-item.is-active[data-media-id]');
      return a ? a.getAttribute('data-media-id') : (imgs[0] && imgs[0].target);
    }

    thumbs.addEventListener('click', function(e){
      var b = e.target.closest('.laf-thumbs__item');
      if(!b) return;
      var target = b.getAttribute('data-target');
      if(!target){ if(imgs.length){ abrir(indicePorTarget(activa())); } return; } // hueco con logo: abre la galeria
      if(typeof gallery.setActiveMedia === 'function'){ gallery.setActiveMedia(target, false); }
      marcar(target);
    });
    if(viewer){
      viewer.addEventListener('slideChanged', function(ev){
        var el = ev.detail && ev.detail.currentElement;
        if(el && el.dataset.mediaId){ marcar(el.dataset.mediaId); }
      });
    }

    function indicePorTarget(t){
      for(var i = 0; i < imgs.length; i++){ if(imgs[i].target === t){ return i; } }
      return 0;
    }

    // Tocar la foto principal abre la galeria. En movil (8 oct 2026, Claudia)
    // se abre en version oscura: fondo negro transparente y la foto grande;
    // tocar la foto la amplia al doble y se puede mover con el dedo.
    // Se escucha en captura para que no se abra ademas el zoom propio de Dawn.
    if(viewer){
      viewer.addEventListener('click', function(e){
        var item = e.target.closest('.product__media-item[data-media-id]');
        if(!item || !imgs.length) return;
        if(e.target.closest('button:not(.product__media-toggle), a, .deferred-media, product-model')) return;
        var i = indicePorTarget(item.getAttribute('data-media-id'));
        if(imgs[i] && imgs[i].target !== item.getAttribute('data-media-id')) return; // video / 3D
        e.preventDefault();
        e.stopPropagation();
        abrir(i);
      }, true);
      viewer.classList.add('laf-zoomable');
    }

    var lb = null, idx = 0;
    function construir(){
      lb = document.createElement('div');
      lb.className = 'laf-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Galería de imágenes');
      lb.innerHTML =
        '<button type="button" class="laf-lb__close" aria-label="Cerrar">&times;</button>' +
        '<div class="laf-lb__stage">' +
          '<button type="button" class="laf-lb__nav laf-lb__nav--prev" aria-label="Imagen anterior">&#8249;</button>' +
          '<img class="laf-lb__img" alt="">' +
          '<button type="button" class="laf-lb__nav laf-lb__nav--next" aria-label="Imagen siguiente">&#8250;</button>' +
        '</div>' +
        '<div class="laf-lb__count"></div>' +
        '<div class="laf-lb__thumbs"></div>';
      var tw = lb.querySelector('.laf-lb__thumbs');
      imgs.forEach(function(im, i){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'laf-lb__thumb';
        b.setAttribute('aria-label', 'Ver imagen ' + (i + 1));
        b.innerHTML = '<img src="' + im.thumb + '" alt="">';
        b.addEventListener('click', function(){ mostrar(i); });
        tw.appendChild(b);
      });
      if(imgs.length < 2){ lb.classList.add('laf-lb--single'); }
      lb.querySelector('.laf-lb__close').addEventListener('click', cerrar);
      lb.querySelector('.laf-lb__nav--prev').addEventListener('click', function(){ mostrar(idx - 1); });
      lb.querySelector('.laf-lb__nav--next').addEventListener('click', function(){ mostrar(idx + 1); });
      lb.addEventListener('click', function(e){ if(e.target === lb || e.target.classList.contains('laf-lb__stage')){ cerrar(); } });
      lb.querySelector('.laf-lb__img').addEventListener('click', function(){
        if(!lb.classList.contains('laf-lb--dark')) return;
        var st = lb.querySelector('.laf-lb__stage');
        var zoom = !lb.classList.contains('is-zoom');
        lb.classList.toggle('is-zoom', zoom);
        if(zoom){ st.scrollLeft = (st.scrollWidth - st.clientWidth) / 2; st.scrollTop = (st.scrollHeight - st.clientHeight) / 2; }
      });
      var x0 = null;
      lb.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function(e){
        if(x0 === null || lb.classList.contains('is-zoom')){ x0 = null; return; }
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if(Math.abs(dx) > 40){ mostrar(idx + (dx < 0 ? 1 : -1)); }
      });
      document.body.appendChild(lb);
    }
    function mostrar(i){
      idx = (i + imgs.length) % imgs.length;
      lb.classList.remove('is-zoom');
      var im = imgs[idx];
      var img = lb.querySelector('.laf-lb__img');
      img.src = im.src; img.alt = im.alt || '';
      lb.querySelector('.laf-lb__count').textContent = imgs.length > 1 ? (idx + 1) + ' / ' + imgs.length : '';
      lb.querySelectorAll('.laf-lb__thumb').forEach(function(b, j){ b.classList.toggle('is-active', j === idx); });
    }
    function teclas(e){
      if(e.key === 'Escape'){ cerrar(); }
      else if(e.key === 'ArrowRight'){ mostrar(idx + 1); }
      else if(e.key === 'ArrowLeft'){ mostrar(idx - 1); }
    }
    function abrir(i){
      if(!imgs.length) return;
      if(!lb){ construir(); }
      lb.classList.toggle('laf-lb--dark', !window.matchMedia('(min-width: 750px)').matches);
      mostrar(i || 0);
      lb.classList.add('abierto');
      document.documentElement.classList.add('laf-lb-open');
      document.addEventListener('keydown', teclas);
      lb.querySelector('.laf-lb__close').focus();
    }
    function cerrar(){
      if(!lb) return;
      lb.classList.remove('abierto');
      document.documentElement.classList.remove('laf-lb-open');
      document.removeEventListener('keydown', teclas);
    }
  }

  onReady(initGaleria);

  /* =========================================================
     5) TARJETAS: toda la tarjeta lleva a la ficha (8 oct 2026, Claudia)
     Ofertas flash, Mas vendidos, buscador/colecciones y relacionados.
     Los botones (Agregar, +, corazon) siguen funcionando como antes:
     solo se actua si el clic NO cae en un boton, input u otro enlace.
     ========================================================= */
  var CARD_SEL = '.laf-card:not(.laf-card--more), .laf-bcard:not(.laf-bcard--more), .lafr__card';
  document.addEventListener('click', function(e){
    var card = e.target.closest ? e.target.closest(CARD_SEL) : null;
    if(!card) return;
    if(e.target.closest('button, input, select, textarea, label, .laf-fav-btn')) return;
    var innerLink = e.target.closest('a[href]');
    if(innerLink && innerLink !== card && card.contains(innerLink)) return; // ya es un enlace: lo hace el navegador
    var link = card.matches('a[href]') ? card : card.querySelector('a[href]');
    if(!link) return;
    var href = link.getAttribute('href');
    if(!href || href === '#') return;
    e.preventDefault();
    if(e.metaKey || e.ctrlKey || e.button === 1){ window.open(href, '_blank'); }
    else { window.location.href = href; }
  });
})();

/* ===== Sugerencias en la cesta (Clau 8 oct 2026) =====
   Dentro del cajon de la cesta, debajo de los productos. Hasta 8 productos de
   7 EUR o menos (primero los de 5 EUR o menos), disponibles y NUNCA
   medicamentos, por orden:
     1) parecidos a lo que hay en la cesta
     2) parecidos a sus favoritos (localStorage "laf_favs")
     3) relacionados con su ultima busqueda (localStorage "laf_ult_busqueda")
     4) reserva: baratos que mas se venden
   El filtro lo hace sections/laf-cart-sugerencias.liquid (lf-med-status).
   El boton usa .laf-add[data-variant-id] -> lo gestiona laf-cart.js (aviso,
   contador y cesta actualizada). Nunca sugiere algo que ya esta en la cesta. */
(function(){
  try {
    var q = new URLSearchParams(window.location.search).get('q');
    if(window.location.pathname.indexOf('/search') === 0 && q && q.trim().length > 1){
      localStorage.setItem('laf_ult_busqueda', q.trim().slice(0, 80));
    }
  } catch(e) {}

  var UMBRAL = 5900, cache = { key: null, html: '' }, running = false, timer;
  function eur(c){ return (c/100).toLocaleString('es-ES', {minimumFractionDigits:2, maximumFractionDigits:2}) + ' €'; }
  function esc(t){ return String(t || '').replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function grab(url){
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r){ return r.ok ? r.text() : ''; })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.map.call(doc.querySelectorAll('.laf-sug-datos i[data-vid]'), function(i){
          return { pid: i.getAttribute('data-pid'), vid: i.getAttribute('data-vid'),
            price: parseInt(i.getAttribute('data-price'), 10) || 0, cmp: parseInt(i.getAttribute('data-cmp'), 10) || 0,
            url: i.getAttribute('data-url'), img: i.getAttribute('data-img'), title: i.getAttribute('data-title') };
        });
      }).catch(function(){ return []; });
  }
  function recs(pid){ return grab('/recommendations/products?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=related&section_id=laf-cart-sugerencias'); }
  function favIds(){
    var favs = [];
    try { favs = JSON.parse(localStorage.getItem('laf_favs') || '[]') || []; } catch(e) {}
    return Promise.all(favs.slice(0, 2).map(function(h){
      var handle = typeof h === 'string' ? h : (h && h.handle);
      if(!handle) return null;
      return fetch('/products/' + encodeURIComponent(handle) + '.js').then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){ return p ? p.id : null; }).catch(function(){ return null; });
    })).then(function(ids){ return ids.filter(Boolean); });
  }
  function host(){
    var d = document.querySelector('cart-drawer');
    if(!d || !d.classList.contains('active')) return null;
    var items = d.querySelector('cart-drawer-items');
    if(!items || items.classList.contains('is-empty')) return null;
    var box = items.querySelector('#laf-sug');
    if(!box){ box = document.createElement('div'); box.id = 'laf-sug'; box.className = 'laf-sug'; items.appendChild(box); }
    return box;
  }
  /* si el servidor ya pinto sugerencias (snippets/laf-cart-sug-server) y aqui no sale nada, se dejan las suyas */
  function paint(box, html){ if(html && box.innerHTML !== html){ box.innerHTML = html; } }
  function run(){
    var box = host(); if(!box || running) return;
    if(cache.key !== null){ paint(box, cache.html); }
    running = true;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var inCart = {}; (cart.items || []).forEach(function(it){ inCart[it.product_id] = true; });
      var busq = ''; try { busq = localStorage.getItem('laf_ult_busqueda') || ''; } catch(e) {}
      var falta = UMBRAL - (cart.items_subtotal_price || 0);
      var key = Object.keys(inCart).sort().join(',') + '|' + busq + '|' + (falta > 0 ? falta : 0);
      if(key === cache.key){ running = false; var b = host(); if(b) paint(b, cache.html); return; }
      var grupos = [
        Promise.all((cart.items || []).slice(0, 2).map(function(it){ return recs(it.product_id); })),
        favIds().then(function(ids){ return Promise.all(ids.map(recs)); }),
        busq ? grab('/search?q=' + encodeURIComponent(busq) + '&type=product&options%5Bprefix%5D=last&section_id=laf-cart-sugerencias').then(function(l){ return [l]; }) : Promise.resolve([]),
        grab('/?section_id=laf-cart-sugerencias').then(function(l){ return [l]; })
      ];
      return Promise.all(grupos).then(function(res){
        var vistos = {}, lista = [];
        res.forEach(function(grupo){
          var g = [];
          grupo.forEach(function(l){ l.forEach(function(p){ if(inCart[p.pid] || vistos[p.pid]) return; vistos[p.pid] = true; g.push(p); }); });
          g.sort(function(a, b){ return (a.price > 500) - (b.price > 500); });
          lista = lista.concat(g);
        });
        lista = lista.slice(0, 8);
        var html = '';
        if(lista.length){
          html = '<p class="laf-sug__tit">' + (falta > 0 ? 'Te faltan <b>' + eur(falta) + '</b> para el envío gratis' : 'Completa tu compra') + '</p>' +
            '<div class="laf-sug__fila">' + lista.map(function(p){
              return '<div class="laf-sug__it">' +
                '<a class="laf-sug__img" href="' + esc(p.url) + '"><img src="' + esc(p.img) + '" alt="" loading="lazy" width="96" height="96"></a>' +
                '<a class="laf-sug__nom" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
                '<div class="laf-sug__pr">' + (p.cmp > p.price ? '<s>' + eur(p.cmp) + '</s>' : '') + '<b>' + eur(p.price) + '</b></div>' +
                '<button type="button" class="laf-add laf-sug__add" data-variant-id="' + esc(p.vid) + '">Añadir</button>' +
              '</div>';
            }).join('') + '</div>';
        }
        cache = { key: key, html: html };
        running = false;
        var b = host(); if(b) paint(b, html);
      });
    }).catch(function(){ running = false; });
  }
  function later(){ clearTimeout(timer); timer = setTimeout(run, 150); }
  function watch(){
    var d = document.querySelector('cart-drawer'); if(!d || d.__lafSug) return; d.__lafSug = true;
    new MutationObserver(function(muts){
      for(var i = 0; i < muts.length; i++){
        var t = muts[i].target;
        if(t.closest && t.closest('#laf-sug')) continue;
        later(); return;
      }
    }).observe(d, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', watch); } else { watch(); }
  document.addEventListener('laf:cart:updated', later);
})();

/* ===== Orden de la cesta: del mas nuevo al mas antiguo (Clau 9 oct 2026) =====
   Shopify pone arriba los productos nuevos, pero si se anade otra unidad de un
   producto que ya estaba en la cesta, lo deja donde estaba. Aqui se apunta (en
   este navegador) cuando se anadio cada producto por ultima vez y, cada vez que
   la cesta se pinta o se abre, sus filas se ordenan del mas reciente al mas
   antiguo. Solo cambia el orden en pantalla: cada fila conserva su numero de
   linea, asi que + / - / quitar siguen funcionando igual. Los + y - de dentro de
   la cesta NO mueven el producto (para que no salte debajo del dedo). */
(function(){
  var KEY = 'laf_cesta_orden';
  function leer(){ try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch(e) { return {}; } }
  function guardar(m){
    try {
      var ks = Object.keys(m);
      if(ks.length > 80){ ks.sort(function(a, b){ return m[b] - m[a]; }).slice(80).forEach(function(k){ delete m[k]; }); }
      localStorage.setItem(KEY, JSON.stringify(m));
    } catch(e) {}
  }
  var seq = 0;
  function apuntar(vid){
    if(!vid) return;
    var m = leer(); m[String(vid)] = Date.now() * 1000 + (seq++ % 1000); guardar(m);
  }
  function apuntarDatos(d){
    if(!d) return;
    if(d.variant_id) apuntar(d.variant_id);
    if(d.items && d.items.forEach) d.items.forEach(function(it){ apuntar(it.variant_id || it.id); });
  }
  function vidDe(tr){
    var i = tr.querySelector('[data-quantity-variant-id]');
    return i ? i.getAttribute('data-quantity-variant-id') : '';
  }
  function ordenar(){
    var d = document.querySelector('cart-drawer'); if(!d) return;
    var tb = d.querySelector('.cart-items tbody'); if(!tb) return;
    var filas = Array.prototype.filter.call(tb.children, function(el){ return el.tagName === 'TR' && el.classList.contains('cart-item'); });
    if(filas.length < 2) return;
    if(filas.some(function(tr){ return tr.classList.contains('cart-item__nested-line'); })) return;
    var m = leer();
    var orden = filas.map(function(tr, i){ return { tr: tr, t: m[vidDe(tr)] || 0, i: i }; });
    orden.sort(function(a, b){ return (b.t - a.t) || (a.i - b.i); });
    var cambia = orden.some(function(o, i){ return o.tr !== filas[i]; });
    if(!cambia) return;
    orden.forEach(function(o){ tb.appendChild(o.tr); });
  }
  var timer;
  function luego(){ clearTimeout(timer); timer = setTimeout(ordenar, 0); }
  /* anadidos desde la ficha (product-form) y desde los botones del carrito unificado (laf-cart) */
  /* (PUB_SUB_EVENTS es "const" en constants.js: no cuelga de window, se mira con typeof) */
  function engancha(){
    if(typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(e){
      if(!e || e.source !== 'product-form') return;
      apuntar(e.productVariantId);
      luego();
    });
    return true;
  }
  if(!engancha()){ document.addEventListener('DOMContentLoaded', engancha); }
  document.addEventListener('laf:cart:updated', function(e){ apuntarDatos(e && e.detail); luego(); });
  /* anadidos desde el panel de favoritos */
  function envolverFavs(){
    var f = window.lafRefrescarCarritoSilencioso;
    if(typeof f !== 'function' || f.__lafOrden) return;
    var nf = function(data){ apuntarDatos(data); var r = f.apply(this, arguments); luego(); return r; };
    nf.__lafOrden = true;
    window.lafRefrescarCarritoSilencioso = nf;
  }
  function vigilar(){
    envolverFavs();
    var d = document.querySelector('cart-drawer'); if(!d || d.__lafOrden) return; d.__lafOrden = true;
    new MutationObserver(function(muts){
      for(var i = 0; i < muts.length; i++){
        var t = muts[i].target;
        if(t.closest && t.closest('#laf-sug')) continue;
        if(muts[i].type === 'childList' && t.tagName === 'TBODY') continue;
        luego(); return;
      }
    }).observe(d, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    ordenar();
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', vigilar); } else { vigilar(); }
  window.addEventListener('load', envolverFavs);
})();

/* ===== Salto del icono de la cesta (Clau 15 oct 2026) =====
   Cada vez que cambia el numero del icono de la cesta (anadir desde cualquier
   boton, + / - / quitar en el cajon o en la pagina de la cesta), el icono da
   el mismo "salto" que el corazon de favoritos, EN EL MISMO MOMENTO en que
   cambia el numero. No toca ningun flujo de la cesta: solo mira el numero del
   icono (#cart-icon-bubble). (Clau 15 oct 23:11: sin el "+" volador, solo el
   salto, y a la vez que el numero.) */
(function(){
  if(window.__lafMasCesta) return; window.__lafMasCesta = true;

  var ESTILO = '@keyframes laf-cesta-llegada{0%{transform:scale(1)}25%{transform:scale(1.35)}50%{transform:scale(.92)}70%{transform:scale(1.12)}85%{transform:scale(.97)}100%{transform:scale(1)}}'
    + '#cart-icon-bubble.laf-cesta-pop{animation:laf-cesta-llegada .85s cubic-bezier(0.34,1.56,0.64,1)!important}';
  function ponerEstilo(){
    if(document.getElementById('laf-mas-cesta-css')) return;
    var st = document.createElement('style'); st.id = 'laf-mas-cesta-css'; st.textContent = ESTILO;
    (document.head || document.documentElement).appendChild(st);
  }

  function icono(){ return document.getElementById('cart-icon-bubble'); }
  function cuenta(){
    var ic = icono(); if(!ic) return null;
    var b = ic.querySelector('.cart-count-bubble');
    if(!b || b.style.display === 'none' || b.classList.contains('hidden')) return 0;
    var s = b.querySelector('span[aria-hidden]');
    var txt = s ? s.textContent : b.textContent;
    var n = parseInt(String(txt).replace(/[^0-9]+/g, ' ').trim(), 10);
    return isNaN(n) ? 0 : n;
  }

  function salto(){
    ponerEstilo();
    var ic = icono(); if(!ic) return;
    ic.classList.remove('laf-cesta-pop'); void ic.offsetWidth; ic.classList.add('laf-cesta-pop');
    clearTimeout(ic.__lafPop); ic.__lafPop = setTimeout(function(){ ic.classList.remove('laf-cesta-pop'); }, 900);
  }

  var antes = null;
  function revisar(){
    var n = cuenta(); if(n === null) return;
    if(antes !== null && n !== antes){ salto(); }
    antes = n;
  }
  function vigilar(){
    var ic = icono(); if(!ic || ic.__lafMas) return;
    ic.__lafMas = true;
    ponerEstilo();
    antes = cuenta();
    /* se revisa en el mismo instante del cambio (sin esperas) */
    new MutationObserver(revisar)
      .observe(ic, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style'] });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', vigilar); } else { vigilar(); }
})();
